import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { HttpStatus, salesHomeRoute } from 'config/Api.Config';
import React from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import useLender, { LenderAction } from './Lender.Hooks';
import LenderDelete from './sections/Lender.Delete';
import LenderEdit from './sections/Lender.Edit';
import LenderFilters from './sections/Lender.Filters';
import LenderList from './sections/Lender.List';
import LenderImportExcel from './sections/Lender.ImportExcel';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';

export const lenderIndexRoute = salesHomeRoute + '/lender/:action?/:id?';
export default function LenderIndex() {
  const { lang } = getLocales();
  const lenderHook = useLender();
  const { permissions } = useAuthStore();

  if (!lenderHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={lenderHook}
        render={({ listApi, views, pageRouter }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.lenders} />
                {isMobile && <LenderFilters />}
                &nbsp;
                <Button
                  class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                  active
                  media={<Icon class="fas-plus" />}
                  render={!isMobile && lang.import}
                  onClick={pageRouter.updateParams}
                  disabled={!permissions.CREATE_LENDER}
                  data={{ action: LenderAction.IMPORT_EXCEL }}
                />
                &nbsp;
                <Button
                  class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                  active
                  media={<Icon class="fas-plus" />}
                  render={!isMobile && lang.addNew}
                  onClick={pageRouter.updateParams}
                  disabled={!permissions.CREATE_LENDER}
                  data={{ action: LenderAction.EDIT }}
                />
              </>
            }
            subHeader={isDesktop && <LenderFilters />}
            render={
              <>
                {views.edit && <LenderEdit />}
                {views.delete && <LenderDelete />}
                {views.importExcel && <LenderImportExcel />}
                <LenderList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
